$(document).ready(function () {
	$('.ytp-pause-overlay').css('display', 'none');
	let event = null;
	let header = document.querySelector('.header');
	// var arrayThemes = {};
	// var arraySec = $( '[data-theme]' );
	// $( '.page__screen' ).each( function( index, value ) {
	// 	let key = $( this ).attr( 'data-theme' );
	// 	arrayThemes[ key ] = value;
	//
	// });
	$( window ).scroll(function() {
		if ($(window).scrollTop() > 1050) {
			$('.header').removeClass('header--dark');
		}
	});
	var stopAllYouTubeVideos = () => {
		var iframes = document.querySelectorAll('iframe');
		Array.prototype.forEach.call(iframes, iframe => {
			iframe.contentWindow.postMessage(JSON.stringify({ event: 'command',
				func: 'pauseVideo' }), '*');
		});
	}
	var playAllYouTubeVideos = () => {
		var iframes = document.querySelectorAll('iframe');
		Array.prototype.forEach.call(iframes, iframe => {
			iframe.contentWindow.postMessage(JSON.stringify({ event: 'command',
				func: 'playVideo' }), '*');
		});
	}
	// console.log(arrayThemes);
	let pageSlider = new Swiper('.page', {
		wrapperClass: "page__wrapper",
		slideClass: "page__screen",
		direction: 'vertical',
		slidesPerView: 'auto',
		mousewheel: {},
		speed: 800,
		observer: true,
		observeParents: true,
		observeSlideChildren: true,

		pagination: {
			el: '.page__pagination',
			type: 'bullets',
			clickable: true,
			bulletClass: "page__bullet",
			bulletActiveClass: "bullet_active",
		},

		// scrollbar: {
		// 	el: ".page__scroll",
		// 	dragClass: "page__drag-scroll",
		// 	draggable: true,
		// },
		on: {
			slideChange: function (e) {

				if(pageSlider.realIndex !== 0){
					stopAllYouTubeVideos();

				}
				else{
					playAllYouTubeVideos();
				}
				if (pageSlider.realIndex === pageSlider.slides.length - 1) {

					document.addEventListener("touchstart", function (e) {
						event = e;
					});
					document.addEventListener("touchmove", function (e) {
						var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

						if ((e.touches[0].pageY - event.touches[0].pageY) >= 0) {
							if (scrollTop <= 1) {
								pageSlider.allowTouchMove = true;

							}
							console.log(scrollTop);
						} else {
							pageSlider.allowTouchMove = false;

							console.log(scrollTop);

						}
						// console.log("Move delta: " + (e.touches[0].pageY - event.touches[0].pageY))
					});
					// document.addEventListener("touched", function (e) {
					// 	event = null;
					// });
					$(window).on(' DOMMouseScroll MozMousePixelScroll mousewheel wheel', function (event) {

						var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
						delta = parseInt(event.originalEvent.wheelDelta || -event.originalEvent.deltaY);
						if (delta >= 0) {
							if (scrollTop <= 1) {
								pageSlider.mousewheel.enable();
								pageSlider.allowTouchMove = true;

							}

						} else {
								setTimeout(()=>{
									pageSlider.mousewheel.disable();
									pageSlider.allowTouchMove = false;
									console.log(scrollTop);
								}, 200)


						}

					});

				} else {
					pageSlider.mousewheel.enable();
					$(window).off('DOMMouseScroll MozMousePixelScroll mousewheel wheel');
					pageSlider.allowTouchMove = true;
				}

				$.each(e.slides, (index, value) => {
					if (pageSlider.realIndex === index) {
						if ($(value).attr('data-theme') == 'dark') {
							header.classList.add('header--dark');
						} else {
							header.classList.remove('header--dark');
						}
					}
				});

			}
		}
	});

	$('.seasons-slider').slick({
		arrows: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,

		responsive: [
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 481,
				settings: {
					slidesToShow: 2,
				}
			}
		]
	});


});

// $(window).on(' DOMMouseScroll MozMousePixelScroll mousewheel wheel', function (event) {
// 	var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//
// 	if (scrollTop <= 53)
// 		$('.header').css('background', 'unset');
// 	console.log(scrollTop);
//
// });
